import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-multilanguage-download" })
export class MultilanguageDownloadComponent {
	constructor(private element: HTMLElement) {
		var allDropdowns = Array.from(
			document.querySelectorAll(".js-multilanguage-download-dropdown")
		);

		var childDropdown = this.element.querySelector(
			".js-multilanguage-download-dropdown"
		);

		var childTrigger = this.element.querySelector(
			".js-multilanguage-download-trigger"
		);

		document.addEventListener("click", (e) => {
			if ((e.target as HTMLElement).closest(".js-multilanguage-download"))
				return;
			childDropdown.classList.remove("is-active");
		});

		childTrigger.addEventListener("click", (e) => {
			console.log("t");

			allDropdowns.forEach((item) => {
				if (item == e.target) return;
				item.classList.remove("is-active");
			});

			if (childDropdown.classList.contains("is-active")) {
				childDropdown.classList.remove("is-active");
			} else {
				childDropdown.classList.add("is-active");
			}
		});
	}
}
